import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

const Callback = () => {
  const { isAuthenticated, error, user } = useAuth0();
  const navigate = useNavigate();
  console.log('isAuthenticated', false)

  useEffect(() => {
    if (error) console.log('Auth0 error: ', error)
    if (user) console.log('Auth0 user: ', user)
    if (isAuthenticated) {
      const redirectTo = window.localStorage.getItem('redirectTo') || '/';
      navigate(redirectTo);
      window.localStorage.removeItem('redirectTo');
    }
  }, [isAuthenticated, navigate]);

  return <div></div>;
};

export default Callback;
